var map = {
	"./01mini.webp": 8786,
	"./02mini.webp": 9109,
	"./03mini.webp": 5020,
	"./04mini.webp": 6722,
	"./05mini.webp": 6882,
	"./06mini.webp": 1892,
	"./07mini.webp": 9041,
	"./08mini.webp": 3247,
	"./09mini.webp": 5604,
	"./10mini.webp": 8030,
	"./11mini.webp": 1062,
	"./Umini.webp": 8772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9230;